import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getToken } from 'src/logic/services/token.service';
import { getClientId } from 'src/logic/services/ws.service';
import { WS_URL } from 'src/logic/constants/chat.constants';

export const useWSStore = defineStore('ws', () => {
  const wsUrl = WS_URL;

  let ws: WebSocket | null = null;
  let wsClientId: string | null = null;
  const reconnectDelay = 5000;
  const isConnected = ref(false);
  const updateClientId = ref('');
  let connectInFlight: Promise<void> | null = null;

  function initWebSocket(): void {
    if (!wsClientId) return;

    ws = new WebSocket(`${wsUrl}?client_id=${wsClientId}`);
    const socket = ws;

    socket.onopen = () => {
      isConnected.value = true;
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ salam: 'salam from vue3' }));
      }
    };

    socket.onmessage = (event: MessageEvent) => {
      const msg = event.data.toString();
      console.log('Received:', msg);

      try {
        const data = JSON.parse(msg);
        if (data.event === 'client_chat_status_change') {
          updateClientId.value = data.client_chat_id;
        }
      } catch {
        console.warn(`Invalid message JSON: ${msg}`);
      }
    };

    socket.onclose = () => {
      console.warn('Disconnected. Reconnecting in 5s...');
      isConnected.value = false;
      setTimeout(startWS, reconnectDelay);
    };

    socket.onerror = (err) => {
      console.error('WebSocket error:', err);
    };
  }

  function closeWS(): void {
    ws?.close();
  }

  async function startWS(): Promise<void> {
    if (connectInFlight) return connectInFlight;
    if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) return;

    connectInFlight = (async () => {
    try {
      const clientData = await getClientId(getToken());
      wsClientId = clientData.client_id;
      initWebSocket();
    } catch (err) {
      console.error(`Backend unavailable. Retrying in 5s... (${(err as Error).message})`);
      setTimeout(startWS, reconnectDelay);
    } finally {
      connectInFlight = null;
    }
    })();

    return connectInFlight;
  }

  return { startWS, closeWS, updateClientId, isConnected };
});
